<div class="racing-post-pick-container" data-crlat="racingPostContainer">
    <svg class="racing-post-logo" data-crlat="racingPost.logo">
        <use xlink:href="#racing-post-pick"></use>
    </svg>
    <gh-silk *ngFor="let pick of racingPostPick" [postPickSilk]="pick"></gh-silk>
</div>
